<template lang="pug">
    page(:delegated-loading="true"
        :loading="$wait.waiting(keys.objects.read) || $wait.waiting(keys.effectiveness.history)")
        template(#title="") {{$t('pages.dashboard.service.effectiveness-control.check.title')}}
        template(#content="")
            v-flex(v-if="object.archived" pb-4 pl-0 pt-0 mb-3)
                v-icon(color="primary") {{archive.icon}}
                e-typography-body() {{$t('modules.blocks.content.m-block-content-effectiveness-assessment.archived.text')}}
            m-block-page-assessment-object-info( :item="object")
            e-input-select-assessment-history(v-model="currentAssessmentId", :items="assessmentHistory" class="mt-3")
            m-block-content-effectiveness-assessment(
                :loading="$wait.waiting(keys.effectiveness.historyItem)"
                :assessment-id="currentAssessmentId"
                :assessment="assessmentHistoryItem"
                :assessment-configuration="configuration")
            v-layout(wrap justify-end class="mt-4")
                v-flex(shrink xs12 md6 class="dashboard-service-effectiveness-control-check__buttons")
                    e-button-primary(@click="printTemplate" :loading="$wait.waiting(keys.effectiveness.pdfDownload)")
                        | {{$t('modules.blocks.content.m-block-content-effectiveness-assessment.buttons.print')}}
                v-flex(shrink xs12 md6 class="dashboard-service-effectiveness-control-check__buttons")
                    e-button-primary(@click="pdfDownload" :loading="$wait.waiting(keys.effectiveness.pdfDownload)")
                        | {{$t('modules.blocks.content.m-block-content-effectiveness-assessment.buttons.download')}}

</template>

<script>
    import basePage from "@mixins/components/pages/base";
    import {mapActions, mapGetters} from 'vuex';
    import MBlockContentEffectivenessAssessment from "@modules/blocks/content/m-block-content-effectiveness-assessment";
    import MBlockPageAssessmentObjectInfo from "@modules/blocks/page/concrete/m-block-page-assessment-object-info";
    import FileDownload from 'js-file-download';
    import errorHandler from "@mixins/responses/_errorHandler";
    import notifications from "@mixins/includes/_notifications";

    const name = 'dashboard-service-effectiveness-control-check';
    export default {
        name: name,
        components: {
            MBlockPageAssessmentObjectInfo,
            MBlockContentEffectivenessAssessment
        },
        mixins: [basePage, errorHandler, notifications],
        props: {
            name: {
                type: String,
                default: name
            }
        },
        data: () => ({
            meta: {
                title: 'pages.dashboard.service.effectiveness-control.check.meta.title'
            },
            archive: {
                icon: 'archive'
            },
            currentAssessmentId: null
        }),
        async created() {
            let currentAssessmentId = this.$route.params.riskAssessmentId ? this.$route.params.riskAssessmentId : false
            try {
                await this.requestObject()
                await this.requestAssessmentHistory()
            } catch (e) {
                this.error.handle(e)
            }
            this.loadObjectType({id: this.object._jv.relationships.objectType.data.id});
            this.$iBreadcrumbs.setText(this.object.name);
            this.currentAssessmentId = currentAssessmentId ? currentAssessmentId : this.assessmentHistory[0].id;
        },

        watch: {
            async currentAssessmentId(to, prev) {
                if (to && (to !== prev)) {
                    await this.requestAssessmentHistoryItem();
                }
            }
        },
        computed: {
            ...mapGetters({
                readObject: 'objects/read',
                readAssessmentHistory: 'effectiveness/history',
                readAssessmentHistoryItem: 'effectiveness/historyItem'
            }),
            object() {
                return this.readObject(this.$route.params.objectId)
            },
            assessmentHistory() {
                return this.readAssessmentHistory();
            },
            assessmentHistoryItem() {
                return this.readAssessmentHistoryItem(this.currentAssessmentId).configWithAnswer;
            },
            configuration() {
                return this.readAssessmentHistoryItem(this.currentAssessmentId).config;
            }
        },
        methods: {
            ...mapActions({
                loadObject: 'objects/read',
                loadObjectType: 'objectTypes/read',
                loadAssessmentHistory: "effectiveness/history",
                loadAssessmentHistoryItem: 'effectiveness/historyItem',
                pdfDownloadRequest: 'effectiveness/pdfDownload'
            }),
            async requestObject() {
                await this.loadObject({id: this.$route.params.objectId})
            },
            async requestAssessmentHistory() {
                await this.loadAssessmentHistory({objectId: this.$route.params.objectId})
            },
            async requestAssessmentHistoryItem() {
                await this.loadAssessmentHistoryItem({id: this.currentAssessmentId})
            },
            async pdfDownload() {
                try {
                    let {pdf, filename} = await this.pdfDownloadRequest({id: this.currentAssessmentId})
                    FileDownload(pdf, filename || `effectiveness-assessment${this.currentAssessmentId}.pdf`)
                } catch (e) {
                    // log
                }
            },
            printTemplate() {
                const {href} = this.$router.resolve(this.nav.dashboard.print.risk_assessment.parent() + '/' + this.currentAssessmentId)
                window.open(href, '_blank')
            },
        }
    }
</script>

<style lang="scss">
    .dashboard-service-effectiveness-control-check {
        &__buttons {
            display: flex;
            justify-content: flex-end;

            @include media(md) {
                padding-left: 1.5rem !important;
            }
        }
    }
</style>
